import type { FC } from 'react';
import React from 'react';

import type { ErrorBoundaryProps } from './ErrorBoundary.tsx';
import { ErrorBoundary } from './ErrorBoundary.tsx';
import type { TransparentErrorBoundaryProps } from './TransparentErrorBoundary.tsx';
import { TransparentErrorBoundary } from './TransparentErrorBoundary.tsx';

export function withErrorBoundary(
	errorBoundaryProps: ErrorBoundaryProps,
): <T extends {}>(WrappedComponent: React.ComponentType<T>) => FC<T> {
	return withTypedErrorBoundary(ErrorBoundary, errorBoundaryProps);
}

export function withTransparentErrorBoundary(
	transparentErrorBoundaryProps: TransparentErrorBoundaryProps,
): <T extends {}>(WrappedComponent: React.ComponentType<T>) => FC<T> {
	return withTypedErrorBoundary(TransparentErrorBoundary, transparentErrorBoundaryProps);
}

export function withTypedErrorBoundary<BoundaryPropsT>(
	BoundaryComponent: React.ComponentType<BoundaryPropsT>,
	boundaryProps: BoundaryPropsT,
) {
	return function <T extends {}>(WrappedComponent: React.ComponentType<T>): FC<T> {
		return (wrappedProps: T) => (
			<BoundaryComponent {...boundaryProps}>
				<WrappedComponent {...wrappedProps} />
			</BoundaryComponent>
		);
	};
}
